import { Input } from 'antd';

export const AntInput = Input;

export const AntTextArea = Input.TextArea;

export const AntInputPassword = Input.Password;
